var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.434 5.996 2.38 2.334a.936.936 0 0 1 .282.696c0 .28-.094.512-.282.697a.974.974 0 0 1-.71.277.974.974 0 0 1-.71-.277L.287 5.702a.92.92 0 0 1-.219-.327A1.033 1.033 0 0 1 0 5c0-.13.023-.256.07-.375a.92.92 0 0 1 .218-.327L4.393.278A.974.974 0 0 1 5.103 0c.285 0 .522.092.71.277a.936.936 0 0 1 .283.697c0 .28-.094.511-.282.696l-2.38 2.334H13.97V1.5c0-.28.098-.515.293-.708a.991.991 0 0 1 .722-.288c.285 0 .525.096.721.288A.953.953 0 0 1 16 1.5v2.505a1.9 1.9 0 0 1-.594 1.41 1.977 1.977 0 0 1-1.436.582H3.434z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.dffb162ed90451797e51b4ac8aa7e139.svg";
export { ForwardRef as ReactComponent };